<script setup>
import { computed } from "vue";
import Navbar from "@/components/Navbars/Topnav.vue";
import AppFooter from "@/components/Dashboard/Footer.vue";
import Sidenav from "@/components/Navbars/SidenavBase.vue";
import { useMainStore } from "@/store/MainStore";

const store = useMainStore();

const showNavbar = computed(() => store.showNavbar);
const showFooter = false;

// Show dev mode banner
const devMode = import.meta.env.DEV;

const navClasses = computed(() => {
  return {
    "position-sticky bg-white left-auto top-2 z-index-sticky":
        store.isNavFixed && !store.darkMode,
    "position-sticky bg-dark left-auto top-2 z-index-sticky":
        store.isNavFixed && store.darkMode,
    "position-absolute px-4 mx-0 w-100 z-index-2": store.isAbsolute,
    "px-0 mx-4": !store.isAbsolute,
  };
});

const isAbsolute = computed(() => store.isAbsolute);
const showSidenav = computed(() => store.showSidenav);

const byeForFive = () => {
  console.warn("Dev mode banner will disappear in 5 seconds...");
  setTimeout(() => {
    const banner = document.getElementById("dev-mode-banner");
    if (banner) {
      banner.style.transition = "opacity 1s ease-out";
      banner.style.opacity = "0";
      setTimeout(() => {
        banner.remove();
      }, 1000);
    }
  }, 700);
}
</script>

<template>

  <div class="dashboard-layout">
    <Sidenav v-if="showSidenav" />

    <main
        :class="[
        'main-content position-relative max-height-vh-100 h-100 border-radius-lg',
        isAbsolute ? 'position-absolute' : '',
      ]"
    >
      <div
          class="mb-2 navbar bg-gradient-warning navbar-main navbar-expand-lg d-flex justify-content-center align-items-center p-4 mx-4 shadow-none border-radius-xl position-sticky shadow-blur mt-2 left-auto z-index-sticky"
          v-if="devMode"
          id="dev-mode-banner"
      >
        <a @click="byeForFive" class="p-0 m-0 text-white" id="user-verify-banner">Dev Mode</a>
      </div>
      <!-- nav -->

      <Navbar :class="[navClasses]" v-if="showNavbar" v-slot="{ Component }">
        <component :is="Component" />
      </Navbar>

      <slot />

      <!-- Footer disabled currently -->
      <app-footer v-show="showFooter" />
    </main>
  </div>
</template>

<style scoped>

</style>